export enum ScenarioRequirementStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete'
}
